// Route options, shared by the server and the app so both read them the same way.
//   style:       'normal' (Google picks the best order) or 'farthest' (drive out to the farthest stop first,
//                then work back toward the lab)
//   fastest:     true = fastest route, false = fewest miles
//   hours:       plan around office hours
//   avoidTolls:  no toll roads
//   returnToLab: the route ends back at the lab (off: ends at the last stop)
//
// Where they come from, first match wins:
//   1. this driver's route for this day (routes/{date}_{email}.opt), set in Plan route or by the driver
//   2. this driver's own defaults (staff/{email}.opt)
//   3. the day's options from the older Plan route row (days/{date}.opt)
//   4. the lab defaults in Settings
export const OPTION_KEYS = ['style', 'fastest', 'hours', 'avoidTolls', 'returnToLab'];
export const BUILT_IN = { style: 'normal', fastest: true, hours: true, avoidTolls: false, returnToLab: true };

const LEGACY = { fastest: 'optFastest', hours: 'optHours', avoidTolls: 'optAvoidTolls', returnToLab: 'returnToLab', style: 'optStyle' };
const ok = (k, v) => (k === 'style' ? v === 'normal' || v === 'farthest' : typeof v === 'boolean');

/** Lab-wide defaults from Settings (config/lab). */
export function labDefaults(lab = {}) {
  const out = { ...BUILT_IN };
  for (const k of OPTION_KEYS) if (ok(k, lab[LEGACY[k]])) out[k] = lab[LEGACY[k]];
  return out;
}

/** The options one driver's route uses on one day. */
export function resolveOptions({ lab = {}, day = {}, staff = {}, route = {} } = {}) {
  const out = labDefaults(lab);
  const dayOpt = day.opt || {};
  for (const k of OPTION_KEYS) if (ok(k, dayOpt[LEGACY[k]])) out[k] = dayOpt[LEGACY[k]];
  for (const k of OPTION_KEYS) if (ok(k, staff.opt?.[k])) out[k] = staff.opt[k];
  if (typeof route.endAtLab === 'boolean') out.returnToLab = route.endAtLab;
  for (const k of OPTION_KEYS) if (ok(k, route.opt?.[k])) out[k] = route.opt[k];
  return out;
}

/** Keep only valid option values (for saving what someone picked). */
export function cleanOptions(o = {}) {
  const out = {};
  for (const k of OPTION_KEYS) if (ok(k, o[k])) out[k] = o[k];
  return out;
}

export const styleLabel = (s) => (s === 'farthest' ? 'Farthest stop first, then work back' : 'Best order');
